module.exports = __webpack_public_path__ + "static/media/Offer3.e1c19395.png";